export const expression = {
    name: 'expression',
    params: {
        entityConfig: {
            name: 'expression'
        }
    }
};
